/* eslint-disable */
import { useState, useEffect } from "react";
import { Form, Field, useFormState } from "react-final-form";
import DatePicker from "react-datepicker";
import Select from "react-select";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import useCustomerHook from "../customers/useCustomerHook";
import AddPaymentForm from "./components/form";

const AddPayment = () => {
  const [menu, setMenu] = useState(false);
  const { customers } = useCustomerHook();
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const invoiceOptions = [{ id: "Afganistan", text: "List Empty" }];

  const paymentOptions = [
    { value: "payment", label: "Select Payment mode" },
    { value: "Afganistan", label: "Cash" },
    { value: "Albania", label: "Credit" },
    { value: "Algeria", label: "Cheque" },
  ];
  const formattedOptions = (options) =>
    options?.map((option) => ({
      value: option.id,
      label: option?.user?.full_name,
      data: option,
    }));
  // useEffect(() => {
  //   let elements = Array.from(
  //     document.getElementsByClassName("react-datepicker-wrapper")
  //   );
  //   elements.map((element) => element.classList.add("width-100"));
  // }, []);

  const onSubmit = (values) => {
    console.log("Form Submitted:", values);
  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Accounts</h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <AddPaymentForm customers={customers} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPayment;
